import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from '../ui/dialog';
import { Store } from 'lucide-react';

export default function ViewOutletsDialog({ open, onClose, recipeId, recipeName }) {
  const { getHeaders, API } = useAuth();
  const [outlets, setOutlets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!open || !recipeId) return;
    setLoading(true);
    axios.get(`${API}/recipes/${recipeId}/outlets`, { headers: getHeaders() })
      .then(r => setOutlets(r.data.items || []))
      .catch(() => setOutlets([]))
      .finally(() => setLoading(false));
  }, [open, recipeId, API, getHeaders]);

  return (
    <Dialog open={open} onOpenChange={o => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="view-outlets-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Store className="w-4 h-4 text-[color:var(--color-primary)]" />
            Assigned outlets
          </DialogTitle>
          <DialogDescription className="text-xs text-[#5C6B64]">
            {recipeName ? <>Outlets with access to <strong>{recipeName}</strong></> : 'Outlets with access to this recipe'}
          </DialogDescription>
        </DialogHeader>
        {loading ? (
          <div className="flex items-center justify-center py-8">
            <div className="animate-spin w-5 h-5 border-2 border-[color:var(--color-primary)] border-t-transparent rounded-full" />
          </div>
        ) : outlets.length === 0 ? (
          <p className="py-6 text-center text-xs text-[#5C6B64]" data-testid="view-outlets-empty">
            Not assigned to any outlet yet.
          </p>
        ) : (
          <div className="max-h-72 overflow-y-auto border border-[#E2E8DF] rounded-md divide-y divide-[#E2E8DF]"
            data-testid="view-outlets-list">
            {outlets.map(o => (
              <div key={o.id} className="flex items-center gap-2 px-3 py-2 text-sm" data-testid={`assigned-outlet-${o.id}`}>
                <Store className="w-3.5 h-3.5 text-[#5C6B64]" />
                <span className="flex-1 text-[#1A2421]">{o.name}</span>
              </div>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
